import React, { useState } from 'react';
import { useMaterialsStore } from '../../../../components/Stores/MaterialsStore';
import { IFutureOrder } from '../../../../sp-types/FutureOrderType';
import { FutureOrdersTableSkeleton } from './FutureOrdersTableSkeleton';
import { FutureOrderTableByMaterials } from './FutureOrderTableByMaterials';
import FutureOrderTableByOrders from './FutureOrderTableByOrders';
import { Tab, Tabs } from '@mui/material';
import { FOIcon } from './components/FutureOrdersIcons';
import { LoadingSpinnerOverlay } from '../../../../components/UI-Elements/LoadingSpinnerOverlay';

const BLUE = '#6571FF';
const GRAY500 = '#606060';

const getColor = (selected: boolean, disabled: boolean): string => (selected ? BLUE : disabled ? '#E0E0E0' : GRAY500);
interface Props {
  componentDataState: 'loading' | 'missing' | 'fetched';
  futureOrders: IFutureOrder[];
  currentSelectedMaterialId: string;
  refetchOrders: () => void;
  isEditEnabled: boolean;
}

export const FutureOrdersTables: React.FC<Props> = ({
  componentDataState,
  futureOrders,
  currentSelectedMaterialId,
  refetchOrders,
  isEditEnabled,
}) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const [selectedTable, setSelectedTable] = useState('Material');
  const { materialsMap } = useMaterialsStore();

  const tableTypes: { icon: string; value: string; disabled?: boolean }[] = [
    { icon: 'materials', value: 'Material' },
    { icon: 'orders', value: 'Order' },
    { icon: 'calendar', value: 'Month', disabled: true },
  ];

  return (
    <div className="flex flex-col grow bg-white shadow-sm p-3">
      <div className="flex">
        <Tabs className="border-b border-gray-100" value={selectedTable} sx={{ '.MuiTab-root': { minHeight: '3rem' } }}>
          {tableTypes.map((item, index) => (
            <Tab
              key={index}
              disabled={item.disabled}
              onClick={() => (item.disabled ? '' : setSelectedTable(item.value))}
              className="gap-2 px-2 m-0"
              icon={<FOIcon type={item.icon} color={getColor(selectedTable === item.value, !!item.disabled)} />}
              iconPosition="start"
              label={item.value}
              value={item.value}
              sx={{ color: selectedTable === item.value ? BLUE : GRAY500 }}
            ></Tab>
          ))}
        </Tabs>
      </div>
      {componentDataState === 'loading' && <FutureOrdersTableSkeleton />}
      {(componentDataState === 'fetched' || componentDataState === 'missing') && (
        <div className="flex-grow mt-[1.25rem] overflow-y-scroll d h-0">
          {selectedTable === 'Material' && (
            <div className="flex flex-row">
              {materialsMap && (
                <FutureOrderTableByMaterials
                  futureOrders={futureOrders}
                  currentMaterialId={currentSelectedMaterialId}
                  setIsLoading={setIsLoading}
                  refetchOrders={refetchOrders}
                  isEditEnabled={isEditEnabled}
                />
              )}
            </div>
          )}
          {selectedTable === 'Order' && (
            <div className="flex flex-row">
              {materialsMap && (
                <FutureOrderTableByOrders
                  futureOrders={futureOrders}
                  currentMaterialId={currentSelectedMaterialId}
                  setIsLoading={setIsLoading}
                  refetchOrders={refetchOrders}
                  isEditEnabled={isEditEnabled}
                />
              )}
            </div>
          )}
        </div>
      )}
      {isLoading && <LoadingSpinnerOverlay size={64} />}
    </div>
  );
};
